import React, {useMemo} from "react";
import objectPath from "object-path";
import {useHtmlClassService} from "../../layout";
import {Demo1Dashboard} from "./Demo1Dashboard";
import {AdminDashboard} from "./AdminDashboard";
import {Demo3Dashboard} from "./Demo3Dashboard";
import {Demo4Dashboard} from "./Demo4Dashboard";
import {Demo5Dashboard} from "./Demo5Dashboard";
import {Demo6Dashboard} from "./Demo6Dashboard";
import {Demo7Dashboard} from "./Demo7Dashboard";
import {useSelector} from "react-redux";
import {IsPortalUser, IsSuperUser} from "../../_helpers/AccessControlHelpers";
import {BuyerDashboard} from "./BuyerDashboard";

export function Dashboard() {

    const {user} = useSelector((state) => state.auth);

    const uiService = useHtmlClassService();
    const layoutProps = useMemo(() => {
        return {
            demo: objectPath.get(
                uiService.config,
                "demo"
            )
        };
    }, [uiService]);
    return <>
        {/*<Demo1Dashboard />*/}

        {IsSuperUser(user) && (<AdminDashboard/>)}

        {IsPortalUser(user) && <BuyerDashboard/>}
        
        {/*<Demo3Dashboard />*/}
    </>;
}
